var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveys = function SvgSurveys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".surveys_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.88 15.119-7.63 7.631-3.75.75.75-3.75 7.63-7.631a2.116 2.116 0 0 1 2.992 0l.008.009a2.113 2.113 0 0 1 0 2.991M14.5 13.5v-8h-11v12.999l6 .001",
    className: "surveys_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10V3.5a1 1 0 0 0-1-1h-4.448a3.329 3.329 0 0 0-6.1 0H1.5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h8M6.5 8.5h5M6.5 11.5h5M6.5 14.5h5",
    className: "surveys_svg__a"
  })));
};
export default SvgSurveys;